'use strict';

angular.module('DoohApps').service('MediaAssetsBLL', ['$filter', 'MediaAssets', 'MediaAssetsFile', 'LanguageData', 'MediaAssetsDataFilter', 'NewMediaAssetFile', 'UploadFileStorage', 'FileUpload',
    function ($filter, MediaAssets, MediaAssetsFile, LanguageData, MediaAssetsDataFilter, NewMediaAssetFile, UploadFileStorage, FileUpload) {
        this.GetMediaAssetsList = function (callback, objectFilterOptions) {
            MediaAssets.getMediaAssetsList(function (data) { callback(data) }, objectFilterOptions);
        }

        this.getTagList = function (callback, filter, langID) {
            MediaAssets.getTagList(function (data) { callback(data) }, { filter: filter, languageID: langID });
        }

        this.updateMediaAsset = function (mediaFile, callback) {
            MediaAssets.updateMediaAssets(function (data) {
                mediaFile.NewIconGenerated = false;
                responseHandler(callback, data);
            }, mediaFile);
        }

        this.addNewMediaAsset = function (callback, newFile) {
            MediaAssets.addMediaAssets(function (data) { callback(data) }, newFile);
        }

        this.uploadMediaAssets = function (assets, onProgress, onUploaded, onError, companyId) {
            for (var i = 0; i < assets.length; i++) {
                var fileSize = assets[i].Size / 1024;
                assets[i].FileSize = (fileSize > 1024) ? Math.round((fileSize / 1024)).toFixed(2) + ' MB' : Math.round(fileSize).toFixed(2) + ' KB';
                assets[i].SnapshotFromSecond = 1;
                assets[i].UploadingProgress = 0;
                assets[i].UploadingProgressBar = 0;

                FileUpload.getAssetUploadUrl(function (asset, url, token) {
                    FileUpload.upload({
                        file: asset.file,
                        url,
                        token,
                        onProgress: (percentComplete, onCancel) => onProgress(percentComplete, asset, onCancel),
                        onSuccess: _url => onUploaded(_url, asset),
                        onError: () => onError(asset),
                        companyId
                    });
                }, assets[i], companyId);
            }
        }

        this.deleteSelectedMediaAssets = function (callback, mediaAssets) {
            MediaAssets.deleteSelectedMediaAssets(function (data) { callback(data) }, mediaAssets);
        }

        this.archiveAssets = function (callback, mediaAssetIdList) {
            MediaAssets.addSelectedToArchive(function (data) { callback(data); }, mediaAssetIdList);
        }

        this.checkMediaAssetsUse = function (callback, assets) {
            MediaAssets.checkMediaAssetsUse(function (data) { callback(data); }, assets);
        }

        this.addFolder = function (callback, folder) {
            MediaAssets.addFolder(function (data) { callback(data) }, folder);
        }

        this.getFolderPath = function (callback, folderID) {
            MediaAssets.getFolderPath(function (data) { callback(data) }, folderID);
        }

        this.updateFolder = function (callback, folder) {
            MediaAssets.updateFolder(function (data) { callback(data) }, folder);
        }

        this.checkFolderAssets = function (callback, folderID, count, offset) {
            MediaAssets.checkFolderAssets(function (data) { callback(data) }, folderID, count, offset);
        }

        this.deleteFolder = function (callback, folderID) {
            MediaAssets.deleteFolder(function (data) { callback(data) }, folderID);
        }

        this.getFolderTree = function (callback, company) {
            MediaAssets.getFolderTree(function (data) { callback(data) }, company);
        }
        this.changeAssetsLocation = function (callback, assets, newFolder) {
            MediaAssets.changeAssetsLocation(function (data) { callback(data) }, assets, newFolder);
        }
        this.getMediaAssetsFileByIds = function (callback, ids) {
            MediaAssetsFile.getMediaAssetsFileByIds(function (data) { callback(data) }, ids);
        }

        this.getSnapshotFromVideo = function (callback, mediaFile) {
            MediaAssets.getSnapshotFromVideo(function (data) { callback(data) }, {
                FileUrl: mediaFile.FileURL,
                SnapshotFromSecond: mediaFile.SnapshotFromSecond
            });
        }

        this.addAttachedFile = function (callback, campaignID, mediaAssetID) {
            MediaAssets.addAttachedFile(function (data) {
                callback(data);
            }, { campaignID: campaignID, mediaAssetID: mediaAssetID })
        }

        this.deleteAttachedFile = function (callback, campaignID, attachedFileID) {
            MediaAssets.deleteAttachedFile(function (data) {
                callback(data);
            }, { campaignID: campaignID, fileID: attachedFileID })
        }

        this.saveExternalCampaign = function (callback, campaign, assetIDs, linkedCampaignIDs, externalConfiguration) {
            MediaAssets.saveExternalCampaign(function (data) {
                callback(data);
            }, { campaign: campaign, assetIDs: assetIDs, linkedCampaignIDs: linkedCampaignIDs, externalConfiguration: externalConfiguration });
        }

        this.assetUsed = function (asset) {
            return asset.Campaigns.length > 0 || asset.Apps.length > 0 || asset.ExternalCampaigns.length > 0;
        }

        this.getLanguagesForCompany = function (callback) {
            LanguageData.getLanguagesForCompany(function (data) {
                responseHandler(callback, data);
            });
        }

        this.addRemoveLanguagesToFromCompany = function (callback, languages) {
            LanguageData.addRemoveLanguagesToFromCompany(function (data) {
                responseHandler(callback, data);
            }, languages);
        }

        this.getMediaAssetsLanguageData = function (callback, assetId) {
            MediaAssets.getMediaAssetsLanguageData(function (data) {
                responseHandler(callback, data);
            }, assetId);
        }

        function responseHandler(callback, data) {
            callback({
                hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                error: getErrorMessage(data),
                message: data.message || (data.Data != undefined ? data.Data.message : null),
                content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
            });
        }

        function getErrorMessage(data) {
            if (data.hasError)
                return data.errors[0];

            return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
        }
    }]);